
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "Company": [
      "PrivateCompany",
      "PublicCompany",
      "UserCompany"
    ],
    "CreatePoolResult": [
      "PoolCreationJob",
      "UserCompanyListing"
    ],
    "Job": [
      "OfferingCreationJob",
      "PoolCreationJob",
      "SaleCreationJob"
    ],
    "Listing": [
      "PublicListing",
      "UserCompanyListing"
    ],
    "Loan": [
      "AutoLoan",
      "CRELoan",
      "HELOCLoan",
      "HomeLoan",
      "MarineLoan",
      "MemberBusinessLoan",
      "UnsecuredPersonalLoan"
    ],
    "SaleView": [
      "Sale",
      "SaleAnnouncement"
    ],
    "TimelineCard": [
      "BidCard",
      "CarveDetailsCard",
      "CounterpartyCard",
      "CounterpartyInsightsCard",
      "DealDocumentsCard",
      "DiligenceCard",
      "FundingScheduleDetailsCard",
      "FundingScheduleInputCard",
      "LoansCard",
      "PlaceBidCard",
      "PlaceholderCard",
      "SettlementCard",
      "StratificationsCard",
      "WireConfirmationCard"
    ]
  }
};
      export default result;
    